import React from 'react';

interface Props {
  hidden?: boolean;
}

function Icon({ hidden }: Props) {
  return (
    <svg
      style={{ opacity: Number(!hidden) }}
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon_checkbox_indeterminate'
      width='18'
      height='18'
      fill='none'
      viewBox='0 0 18 18'
    >
      <path stroke='#2B47E7' strokeLinecap='round' strokeWidth='2' d='M4 9h10' fill='none' />
      <path
        stroke='#2B47E7'
        strokeWidth='2'
        d='M2 1h14a1 1 0 011 1v14a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1z'
        fill='none'
      />
      <path
        stroke='#fff'
        strokeOpacity='0.5'
        strokeWidth='2'
        d='M2 1h14a1 1 0 011 1v14a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1z'
        fill='none'
      />
    </svg>
  );
}

export default Icon;
